import React from 'react';
import { 
  Shield, 
  Key, 
  Lock, 
  Smartphone, 
  Fingerprint,  
  FileText,
  AlertTriangle,
  RefreshCw
} from 'lucide-react';

/**
 * Компонент с советами по безопасности паролей
 */
const SecurityTipsSidebar = () => {
  const securityTips = [
    {
      icon: Key,
      title: 'Уникальные пароли',
      description: 'Используйте разные пароли для разных сервисов, чтобы защититься от массовых утечек.'
    },
    {
      icon: RefreshCw,
      title: 'Регулярное обновление',
      description: 'Меняйте пароли от важных аккаунтов каждые 3-6 месяцев.'
    },
    {
      icon: Lock,
      title: 'Менеджер паролей',
      description: 'Используйте менеджер паролей, чтобы безопасно хранить сложные пароли.'
    },
    {
      icon: Smartphone,
      title: 'Двухфакторная аутентификация',
      description: 'Включите 2FA на всех важных аккаунтах для дополнительной защиты.'
    },
    {
      icon: Fingerprint,
      title: 'Биометрия',
      description: 'Где возможно, используйте биометрические данные вместе с паролем.'
    },
    {
      icon: FileText,
      title: 'Парольная фраза',
      description: 'Длинные парольные фразы могут быть более надежными и легкими для запоминания.'
    },
    {
      icon: AlertTriangle,
      title: 'Проверка утечек',
      description: 'Регулярно проверяйте, не попали ли ваши пароли в утечки данных.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Shield className="w-5 h-5 mr-2 text-violet-500" />
        Советы по безопасности
      </h3>

      <div className="space-y-3">
        {securityTips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-violet-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Shield className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Проверка надежности
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Надежный пароль – основа цифровой безопасности. В России ежедневно происходят тысячи попыток взлома аккаунтов.
            </p>
            <a 
              href="#password-check" 
              className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors block text-center"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('button[aria-controls="password-checker"]').click();
              }}
            >
              Проверить пароль
            </a>
          </div>
        </div>
      </div>
      
      <div className="mt-4 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800 rounded-lg">
        <p className="text-xs text-amber-700 dark:text-amber-300">
          По данным Роскомнадзора и НКЦКИ, в 2024 году более 60% утечек данных в России произошли из-за слабых паролей или их повторного использования на разных сервисах.
        </p>
      </div>
    </div>
  );
};

export default SecurityTipsSidebar;